// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectall-input-radio {
    width: 17px;
    height: 17px;
    margin-right: 10px;
    accent-color: #FF5D02;
}`, "",{"version":3,"sources":["webpack://./src/pages/photoApprovalPage/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB","sourcesContent":[".selectall-input-radio {\n    width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    accent-color: #FF5D02;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
